/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../index';

/**
 * @example
 *     {
 *         body: "string"
 *     }
 */
export interface DidCommMessageSignRequest {
    /** All supported DID methods. Default is "web". */
    didMethod?: Truvity.DidCommMessageSignRequestDidMethod;
    /** The DIDCOMMMessage to sign. */
    body: string;
}
